function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { diacritics } from './diacritics';
export var getIconStyles = icon => {
  return {
    color: (icon == null ? void 0 : icon.color) || 'brand.500',
    h: (icon == null ? void 0 : icon.size) || 8,
    w: (icon == null ? void 0 : icon.size) || 8
  };
};
export var getOptionLabel = option => option.label;
export var getOptionValue = option => option.value;
export var findOption = (value, options) => {
  var option = options.find(option => option.value === value);
  return option || options[0];
};
export var trimString = str => str.replace(/^\s+|\s+$/g, '');

var defaultStringify = option => option.label + " " + option.value; // filter compliments of `react-select` https://github.com/jedwatson/react-select


export var createFilter = config => (option, rawInput) => {
  var {
    ignoreCase,
    ignoreAccents,
    stringify,
    trim,
    matchFrom
  } = _extends({
    ignoreCase: true,
    ignoreAccents: true,
    stringify: defaultStringify,
    trim: true,
    matchFrom: 'any'
  }, config);

  var input = trim ? trimString(rawInput) : rawInput;
  var candidate = trim ? trimString(stringify(option)) : stringify(option);

  if (ignoreCase) {
    input = input.toLowerCase();
    candidate = candidate.toLowerCase();
  }

  if (ignoreAccents) {
    input = stripDiacritics(input);
    candidate = stripDiacritics(candidate);
  }

  return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
};
export var filterOptions = (options, searchValue) => {
  return options.filter(option => option.value.match(searchValue));
};
var anyDiacritic = new RegExp('[' + diacritics.map(d => d.letters).join('') + ']', 'g');
var diacriticToBase = {};

for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];

  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}

export var stripDiacritics = str => {
  return str.replace(anyDiacritic, match => diacriticToBase[match]).toLocaleLowerCase();
};
//# sourceMappingURL=index.js.map